import React from "react";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Typography,
} from "@mui/material";

interface LegalRepresentativeProps {
    register: any;
    errors: any;
}

const LegalRepresentativeCheck: React.FC<LegalRepresentativeProps> = ({ register, errors }) => {
  return (
    <FormGroup>
      <FormControlLabel
        {...register("legalRepresentativeCheck")}
        control={<Checkbox />}
        label={
          <Typography fontSize={13}>
            Sou o representante legal da empresa.
          </Typography>
        }
      />
      {errors.legalRepresentativeCheck && (
        <FormHelperText error>
          {errors.legalRepresentativeCheck.message}
        </FormHelperText>
      )}
    </FormGroup>
  );
};

export default LegalRepresentativeCheck;
